import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54560256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-column" }
const _hoisted_4 = { class: "mt-2 mt-lg-4 content" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column align-items-end"
}
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = {
  key: 0,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("b", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", {
      id: "default",
      class: _normalizeClass(["mt-2", {'mt-lg-4':!_ctx.title}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["my-2", {'text-center': _ctx.hideCta}])
          }, _toDisplayString(_ctx.errorMessages), 3)
        ])
      ]),
      (!_ctx.hideCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AsahiButton, {
                  type: "fixed",
                  color: _ctx.showContinueBtn ? 'secondary' : 'primary',
                  class: "mt-4 w-100",
                  onClick: _cache[0] || (_cache[0] = () => _ctx.closeModal())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.closeBtnLabel || _ctx.$t('Ok')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              (_ctx.showContinueBtn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_AsahiButton, {
                      type: "fixed",
                      color: "primary",
                      class: "mt-4 w-100",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.continueModal())
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.continueBtnLabel || _ctx.$t('Continue')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}